import React from 'react';

type UserTimeWorkedProps = {};

const UserTimeWorked = (props: UserTimeWorkedProps) => {
  return <div></div>;
};

export default UserTimeWorked;
